import { Component } from '@angular/core';

/**
 * Summary
 *    Provides a tabbed navigation interface for page content and resource
 *    admin pages
 *
 * @copyright 2017 ReallyB2B Limited
 */
@Component({
  selector: 'app-admin-content',
  templateUrl: './admin-content.component.html',
})
export class AdminContentComponent {
  constructor() {}
}
